import Vue from 'vue'
import Vuex from 'vuex'
import moment from 'moment'

import COVER from '@/utils/COVER'
import COVERAPP from '@/utils/COVERAPP'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
		pageLoading: true, //加载动画
        dialogData: null, //弹框数据
        page: 1, //列表页页码
        userInfo: {}, //获取用户信息
        openDownLoadFlag: false, //引流弹框
        toastData: null, //toast数据
        isShowLotteryToast: false,  // 是否显示抽奖提示
        activityData: {},
    },
    mutations: {
		setPageLoading(state, flag) {
			state.pageLoading = flag
		},
		setDialogData(state, data) {
			state.dialogData = data
        },
        setPage(state, num) {
            state.page = num
        },
		setUserInfo(state, data) {
            state.userInfo = data;
            sessionStorage.setItem('COVER_USERINFO', JSON.stringify(data));
        },
        setOpenDownLoadFlag (state, flag) {
            state.openDownLoadFlag = flag
        },
        setToastData (state, data) {
            state.toastData = data
        },
        setActivityData(state, data) {
            state.activityData = data;
        },
    },
    actions: {
        setPageLoadingAsync({ commit, state }, flag) {
          commit('setPageLoading', flag)
		},
		setDialogDataAsync({ commit, state }, data) {
			commit('setDialogData', data)
		},
		setUserInfoAsync({ commit, state }, data) {
            if(COVERAPP.Attribute.isApp()) {
                let isLoad_Bridging = setInterval(()=> {
                    try {
                        COVERAPP.Method.GetUser({
                            callback(res) {
                                clearInterval(isLoad_Bridging);
                                let userinfo = JSON.parse(res);
                                if(!COVER.isEmpty(userinfo.user_id)){
									userinfo.origin = 'app';
									if (COVERAPP.Attribute.isIOS()) {
										userinfo.nickname = decodeURIComponent(escape(window.atob(userinfo.nickname)));
									}
                                    commit('setUserInfo', userinfo);
                                }
                            }
                        });
                    } catch (e) {}
                }, 300) 
            } else {
                COVER.getUser((res) => {
					commit('setUserInfo', JSON.parse(JSON.stringify(res)));
                })
            }
		},
        setShowLotteryToast({ commit, state }, overVote = 0) {
            const activityData = state.activityData
            const lotteryToastDayCount = activityData.lotteryToastDayCount || 0  // 每日抽奖弹框阈值
            const voteNumber = activityData.voteNumber || 0  // 投票总数
            const aid = activityData.aid || ''
            const voteCount = voteNumber - overVote + 1
            const isShow = localStorage.getItem('jjvote_lottery_toast_' + aid + '_' + moment().format('YYYYMMDD'))  // 是否显示
            if (!isShow && overVote && voteCount >= lotteryToastDayCount) {
                state.isShowLotteryToast = true
                localStorage.setItem('jjvote_lottery_toast_' + aid + '_' + moment().format('YYYYMMDD'), new Date().getTime())
                COVER.yunTrack(aid, 'adtoast')
            } else {
                state.isShowLotteryToast = false
            }
        },
    }
})